"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEventRefProperty = exports.eventRefPropertyDefinition = void 0;
exports.eventRefPropertyDefinition = {
    view: {
        label: 'Events',
        readonly: true,
        hint: 'Read-only. Please navigate to the content you\'d want to remove or add in order to make changes.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['event-profile'],
        },
    ],
    type: 'child-ref',
    multiple: true,
    name: 'event-ref',
};
const isEventRefProperty = (prop) => {
    return prop.name === exports.eventRefPropertyDefinition.name;
};
exports.isEventRefProperty = isEventRefProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQtcmVmLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvZXZlbnQtcmVmLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMEJBQTBCLEdBQUc7SUFDeEMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFFBQVE7UUFDZixRQUFRLEVBQUUsSUFBSTtRQUNkLElBQUksRUFBRSxrR0FBa0c7S0FDekc7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLGVBQWUsQ0FBQztTQUM1QjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsV0FBVztDQUNjLENBQUE7QUFJMUIsTUFBTSxrQkFBa0IsR0FBRyxDQUFDLElBQWtCLEVBQTRCLEVBQUU7SUFDakYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLGtDQUEwQixDQUFDLElBQUksQ0FBQTtBQUN0RCxDQUFDLENBQUE7QUFGWSxRQUFBLGtCQUFrQixzQkFFOUIifQ==